<template>
  <banner
    v-if="showBanner"
    class="delayed-purchase-banner-component"
    :type="'dashboard'"
    @banner-clicked="bannerClicked"
  >
    <template v-slot:banner-text>
      {{ bannerText }}
    </template>
    <template v-slot:banner-action>
      I'm Ready
    </template>
  </banner>
</template>

<script>
import Banner from '@/components/ui/banner.vue';

export default {
  name: 'DelayedPurchaseBanner',
  components: { Banner },
  props: {
    dashboard: Object,
  },
  computed: {
    allUnrealizedPurchaseReceipts() {
      return this.$store.getters['purchaseReceipts/unrealized'];
    },
    bannerText() {
      if (this.unrealizedPurchaseOrder) {
        if (this.unrealizedPurchaseOrder.daysUntilExpiration) {
          return `Want to start your ${this.unrealizedPurchaseOrder.daysUntilExpiration} day access?`;
        } else {
          return 'Want to start your access?';
        }
      }
    },
    catalogPage() {
      if (this.unrealizedPurchaseOrder) {
        const parentPO = this.$store.getters['purchaseOrders/get'][
          this.unrealizedPurchaseOrder.parentId
        ];
        return this.$store.getters['catalog/pageList'].find(
          (page) =>
            page.visibility &&
            page.purchaseEnabled &&
            page.purchaseOrderId === parentPO?.id,
        );
      }
    },
    showBanner() {
      if (this.allUnrealizedPurchaseReceipts?.length === 0) {
        return false;
      }

      return !!(this.unrealizedPurchaseReceipt && this.catalogPage);
    },
    unrealizedPurchaseOrder() {
      if (this.unrealizedPurchaseReceipt) {
        return this.$store.getters['purchaseOrders/get'][
          this.unrealizedPurchaseReceipt.purchaseOrderId
        ];
      }
    },
    unrealizedPurchaseReceipt() {
      if (this.allUnrealizedPurchaseReceipts?.length > 0) {
        return this.allUnrealizedPurchaseReceipts.find(pr => this.dashboard?.unlockedBy?.includes(pr.purchaseOrderId));
      }
    },
  },
  methods: {
    bannerClicked() {
      const params = {
        source: {
          id: this.dashboard?.id,
          name: this.dashboard?.name,
          type: 'Dashboard',
        },
        po: this.unrealizedPurchaseOrder,
        text: this.bannerText,
      };
      this.$analytics.events.selectedBanner(params);
      this.$modal.show('delayed-purchase-modal', { purchaseReceipt: this.unrealizedPurchaseReceipt, dashboard: this.dashboard });
    },
  },
};
</script>

<style lang="scss">
.delayed-purchase-banner-component ~ .checklist-container {
  display: none;
}
</style>

